module.exports = __webpack_public_path__ + "img/subscribe-illustration.4c2bd825.svg";